import {h} from 'preact';
import {REDIRECT_404_URL} from '@util/URLUtils';
import Modal from '@components/common/Modal';
import {Breadcrumbs} from '@components/common/Breadcrumbs';
import {ScrollToTop, PageNavigation} from './components';
import {CheckoutButton} from './Checkout';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {routes} from './routes';
import {
    getLineItemById,
    getOpenRmaLines,
    getCanceledRmaLines,
    getCartLineData,
    groupLineItemsByAvailability
} from './helpers';
import map from 'ramda/src/map';

function isNonCheckoutPath ( pathname ) {
    return /^((?!checkout).)*$/.test( pathname );
}

export function AppRouter (
    props,
    context
) {
    const {customerEquipment, customerRmas, cart, state} = context;
    const BASENAME = '/account/equipment-repair';
    console.log({customerRmas});
    const openRmaLines = getOpenRmaLines( customerRmas );
    const canceledRmaLines = getCanceledRmaLines( customerRmas );
    const rmaLines = openRmaLines.concat( canceledRmaLines );

    const equipmentList = customerEquipment.map( item => ({
        ...item,
        // todo -> move these to custom @client Apollo resolvers
        isInCart: !!getLineItemById( item.serialId, cart ),
        rmaDetail: getLineItemById( item.serialId, rmaLines )
    }) );
    const cartLineData = getCartLineData( cart, equipmentList );
    const routeContext = {
        ...context,
        equipmentList,
        cartLineData
    };

    return (
        <Router basename={BASENAME}>
            <ScrollToTop>
                <Modal printOnly isOpen={state.isPrintingLabel} id="print-ups-label" size="xl">
                    <img src={`data:application/pdf;base64,${state.shippingLabelImage}`}
                         alt="Shipping Label"/>
                </Modal>

                <Breadcrumbs basename={BASENAME}/>

                <header
                    className="text-center leading-normal md:text-left border-b border-grey-lighter border-solid">
                    <Switch>
                        {routes.map( ( route, index ) =>
                            <Route
                                key={index}
                                path={route.path}
                                exact={true}
                                component={route.pageHeading}
                            /> )
                        }
                        <Route render={props => {
                            window.location.replace( REDIRECT_404_URL )
                        }}/>
                    </Switch>
                    <div className="contain-content pad-content">
                        <Route path="/" render={props => {
                            const lines = groupLineItemsByAvailability( cartLineData );
                            const hasValidCartItems = lines.included && lines.included.length;

                            if ( hasValidCartItems && isNonCheckoutPath( props.location.pathname ) ) {
                                return <CheckoutButton className="md:float-right"
                                                       count={lines.included.length}
                                                       location={props.location}/>
                            }
                        }}/>
                        <Route path="/" render={props => {
                            if ( isNonCheckoutPath( props.location.pathname ) ) {
                                return <PageNavigation pathname={props.location.pathname}/>;
                            }
                        }}/>
                    </div>
                </header>

                <div className="contain-content">
                    <div className="md:flex">
                        <div className="relative space-content flex-grow">
                            <div className="flex-col w-full justify-between">
                                <div className="mt-4">
                                    {routes.map( ( route, index ) => {
                                        const componentProp = route.render
                                            ? {render: route.render( routeContext )}
                                            : {component: route.main};

                                        return <Route
                                            key={index}
                                            path={route.path}
                                            exact={route.exact}
                                            {...componentProp}
                                        />
                                    } )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollToTop>
        </Router>
    );
}
